<template>
    <div name="partnerships" class="partnerships">
        <div class="container">
            <div class="section-header">
                <strong class="title">주요 파트너십</strong>
            </div>

            <ul class="logo-list">
                <li><img class="logo-image" src="../../assets/mobile_barocare/partnerships_logo1.png" alt="케어링"/></li>
                <li><img class="logo-image" src="../../assets/mobile_barocare/partnerships_logo2.png" alt="한국시니어연구소"/></li>
                <li><img class="logo-image" src="../../assets/mobile_barocare/partnerships_logo3.png" alt="성남사랑의병원"/></li>
                <li><img class="logo-image" src="../../assets/mobile_barocare/partnerships_logo4.png" alt="아주편한병원"/></li>
                <li><img class="logo-image" src="../../assets/mobile_barocare/partnerships_logo5.png" alt="연세대학교"/></li>
                <li><img class="logo-image" src="../../assets/mobile_barocare/partnerships_logo6.png" alt="경상국립대학교"/></li>
                <li><img class="logo-image" src="../../assets/mobile_barocare/partnerships_logo7.png" alt="원격의료산업협의회"/></li>
                <li><img class="logo-image" src="../../assets/mobile_barocare/partnerships_logo8.png" alt="한국보건산업진흥원"/></li>
            </ul>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
    name: 'partnerships',
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
        };
    },
    methods: {
       
    },
}
</script>

<style scoped>
    .partnerships{
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        background: #fff;
    }
    .partnerships .container{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        /* height: 770px; */
        margin: 0 auto;
        padding: 53px 20px 123px;
        z-index: 1;
    }
    .section-header{
        width: 100%;
        text-align: center;
    }
    .section-header .title{
        font-family: 'Pretendard';
        font-style: normal;
        font-size: 32px;
        font-weight: 600;
        line-height: 1.6;
        color: #1A1A1A;
    }

    .logo-list{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 5px;
        width: 100%;

        margin-top: 47px;
        padding: 0;
        animation: fadeInUp1 2s;
    }
    .logo-list li{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 100px;
        width: calc(50% - 5px);
        padding: 0;
        border-radius: 10px;
        border: 1px solid #CCC;
        background: #FFF;
    }
    .logo-image{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_barocare/Partnerships.vue